import { render, staticRenderFns } from "./InquiryDetail.vue?vue&type=template&id=f472bf30&scoped=true"
import script from "./InquiryDetail.ts?vue&type=script&lang=ts&external"
export * from "./InquiryDetail.ts?vue&type=script&lang=ts&external"
import style0 from "./InquiryDetail.vue?vue&type=style&index=0&id=f472bf30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f472bf30",
  null
  
)

export default component.exports